<template>
  <div>
    <b-alert
      variant="warning"
      show
    >
      <div class="alert-body text-center font-small-3">
        Yeni kiracı eklemek için bu alanı kullanın.
      </div>
    </b-alert>
    <b-form-group
      label="Kiracı"
      label-for="id_tenants"
    >
      <v-select
        id="id_tenants"
        v-model="dataItem.id_tenants"
        :options="dataList"
        placeholder="Kiracı"
        label="title"
        :reduce="item => item.id"
      />
    </b-form-group>
  </div>
</template>
<script>
import vSelect from 'vue-select'
import { BFormGroup, BAlert } from 'bootstrap-vue'

export default {
  name: 'TenantSelect',
  components: {
    vSelect,
    BFormGroup,
    BAlert,
  },
  computed: {
    dataItem() {
      return this.$store.getters['estateTenants/dataItem']
    },
    dataList() {
      return this.$store.getters['tenants/dataList']
    },
  },
  created() {
    this.getDataList()
  },
  methods: {
    getDataList() {
      this.$store.dispatch('tenants/getDataList')
    },
  },
}
</script>
